import { requiredOrganizationUserPermissions } from '@/entities/OrganizationAccess'
import { type User } from '@/entities'
import type { ObjectId } from '@/utils/objectid'

import { hasOrganizationPermissions } from './hasOrganizationPermissions'

type AdminAccessUser = Pick<User, 'organizations' | 'systemPermissions'>

export const hasSystemAdminAccess = ({ systemPermissions }: AdminAccessUser) =>
    systemPermissions.includes('organization.read') || systemPermissions.includes('organization.write')

export const hasAdminOrganizationAccess = ({
    organizationId,
    user,
}: {
    organizationId: ObjectId
    user: AdminAccessUser
}) => {
    if (hasSystemAdminAccess(user)) {
        return true
    }

    const organizationAccess = user.organizations.find(
        ({ organization }) => organization.toString() === organizationId.toString()
    )

    return hasOrganizationPermissions(organizationAccess, requiredOrganizationUserPermissions, false)
}

export const getAdminOrganizationIds = (user: AdminAccessUser) =>
    user.organizations
        .filter(({ organization }) => hasAdminOrganizationAccess({ organizationId: organization, user }))
        .map(({ organization }) => organization)

export const hasAnyAdminOrganizationAccess = (user: AdminAccessUser) =>
    hasSystemAdminAccess(user) || getAdminOrganizationIds(user).length > 0
